export default "__VITE_ASSET__BgRgS39d__"